module.exports = __webpack_public_path__ + "img/姜长青.d953d9c4.png";